import React from 'react';
import CaseStudy from './CaseStudy/CaseStudy'; 


function App() {
  return (
    <div>
  
      <CaseStudy />
    </div>
  );
}

export default App;
